import { inject, observer } from "mobx-react";

import Default from "./Default";

import { useAbTestComponent } from "@utils";

const abTests = {
    dev_1683_25_11_2025: () => import("./AB_1683"), // 15/01/26 не тестировали еще
};

const AvaWheel = inject("mainStore")(
    observer(({ mainStore }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default, matchValue: "v2" });

        return <Specified />;
    }),
);

export default AvaWheel;
